import { DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
// import { NotificationsService } from "angular2-notifications";
// import { ToastrService } from "ngx-toastr";
import { VoziloView } from "src/app/lookups/vozilo/vozilo-view";
import { NotificationService, QueryParameter } from "yt-ng-framework";

@Component({
    selector: 'yt-transporteri',
    templateUrl: './transporteri.component.html'
  })
  

export class TransporteriComponent implements OnInit{

    constructor(
        protected activeModal: NgbActiveModal,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        private datePipe: DatePipe
    ){
    }

    @Input() Parameters: QueryParameter[];
    formGroup = new FormGroup({
        Pozicija: new FormControl(),
        Crm: new FormControl(),
        VozilaIds: new FormControl(),
        Vozac: new FormControl(),
        NapomenaTransporteri: new FormControl()
      })

    baseUpdateID: number;
    ngOnInit() {
        this.formGroup.patchValue({Pozicija: this.Parameters[0].Value});
        this.formGroup.patchValue({Crm: this.Parameters[1].Value});
        this.formGroup.patchValue({VozilaIds: this.Parameters[2].Value});
        this.formGroup.patchValue({Vozac: this.Parameters[3].Value});
        this.formGroup.patchValue({NapomenaTransporteri: this.Parameters[4].Value});
        if (this.Parameters[6].Value)
            this.formGroup.disable();
        else
            this.formGroup.enable();
        this.baseUpdateID = Number(this.Parameters[5].Value);
    }

    Save(){
        this.activeModal.close(
          this.formGroup.getRawValue()
        )
        // this.translateService.get("[]")
        // this.notificationService.info( 'Dodatna polja', 'Uspešno dopisani podaci na tekući dokument.')
        this.toastrService.info( 'Dodatna polja', 'Uspešno dopisani podaci na tekući dokument.');
      }
  
      Close(){
          this.activeModal.dismiss();
      }

      napomenaTransporteri: string = "";
      DajStavkeVozila(items){
        if (this.baseUpdateID == -1){
          this.napomenaTransporteri = "";    
          if (items){                  
            let niz;
            let foundVozilo: VoziloView;
            if (items != ""){
              niz = items.split(",")
              niz.forEach(item1 =>  {
                foundVozilo = this.VozilaItems.find(item => item.ID == Number(item1));
                if (foundVozilo)  
                {
                  this.napomenaTransporteri += foundVozilo.Naziv + " (";
                  foundVozilo.RgBr ? this.napomenaTransporteri += "Registarski broj: " + foundVozilo.RgBr : "";
                  foundVozilo.VrstaVozila ? this.napomenaTransporteri += ", Vrsta vozila: " + foundVozilo.VrstaVozila : "";

                  let datum: string;
                  foundVozilo.DatumReg ? this.datePipe.transform(new Date(foundVozilo.DatumReg["year"], foundVozilo.DatumReg["month"]-1, foundVozilo.DatumReg["day"]),'dd.MM.yyyy') : "";
            
                  foundVozilo.DatumReg ? this.napomenaTransporteri += ", Datum registracije: " + datum : "";
                  foundVozilo.BrSbDozv ? this.napomenaTransporteri += ", Saobraćajna dozvola broj: " + foundVozilo.BrSbDozv : "";
                  foundVozilo.Marka ? this.napomenaTransporteri += ", Marka: " + foundVozilo.Marka : "";
                  foundVozilo.Model ? this.napomenaTransporteri += ", Model: " + foundVozilo.Model : "";
                  foundVozilo.BrojOsovina ? this.napomenaTransporteri += ", Broj osovina: " + foundVozilo.BrojOsovina : "";
                  foundVozilo.Masa ? this.napomenaTransporteri += ", Masa: " + foundVozilo.Masa : "";
                  foundVozilo.Nosivost ? this.napomenaTransporteri += ", Nosivost: " + foundVozilo.Nosivost : "";
                  foundVozilo.GodinaProizvodnje ? this.napomenaTransporteri += ", Godina proizvodnje: " + foundVozilo.GodinaProizvodnje : "";
                  foundVozilo.Boja ? this.napomenaTransporteri += ", Boja: " + foundVozilo.Boja : "";
                  foundVozilo.BrojSasije ? this.napomenaTransporteri += ",  Broj šasije: " + foundVozilo.BrojSasije : "";
                  this.napomenaTransporteri += ")";
                  this.napomenaTransporteri += "\n";
                }
             
              }
              )
            }
              
          }
          this.formGroup.get('NapomenaTransporteri').setValue(this.napomenaTransporteri);
          this.formGroup.get('NapomenaTransporteri').updateValueAndValidity();
        }
      }

      VozilaItems;
      VozilaGetItems(items){
        this.VozilaItems = items;
      }

}